/*eslint-disable*/
import api from '../'

class StocksApi {
    static list(params, cancelToken = null) {
        return api.axios.get('/stocks', {params, cancelToken})
            .then(response => response.data);
    }

    static create (params) {
        return api.axios.post('/stocks', params)
            .then(response => response.data);
    }

    static delete (id) {
        return api.axios.delete('/stocks/' + id)
            .then(response => response.data);
    }

    static update (params) {
        return api.axios.put('/stocks/' + params.id, params.stock)
            .then(response => response.data);
    }

    static show (id) {
        return api.axios.get('/stocks/' + id)
            .then(response => response.data);
    }
}

export default StocksApi;
